import api from '../../../api/axios';
import { PageableModel } from '../../../api/providers';
import { LOCATION, PLAN } from '../../../constants';
import { LocationModel } from '../../location/providers/types';
import { OrganizationModel } from '../../organization/providers/types';
import { TeamAssignHierarchyRequest } from '../providers/types';

export const getLocationHierarchyByPlanId = async (planId: string): Promise<PageableModel<LocationModel>> => {
  const data = await api
    // .get<any>(`instance/hierarchy`)
    .get<any>(`groupmanagement/instance/locationassigments`)
    .then(response => {
      
      const content = (response.data?.geoTree || []) as unknown as LocationModel[];
      // console.log(content,'CH')
      // const mapActive = (nodes: any[]) => {
      //   nodes.forEach(node => {
      //     if (node.properties && (node.properties.assigned || node.properties.active)) {
      //       node.active = true;
      //     }
      //     if (node.children && node.children.length > 0) {
      //       mapActive(node.children);
      //     }
      //   });
      // };
      // mapActive(content);

      return {
        content: content,
        empty: content.length === 0,
        first: true,
        last: true,
        number: 0,
        numberOfElements: content.length,
        pageable: {
          offset: 0,
          pageNumber: 0,
          pageSize: content.length || 10,
          paged: true,
          sort: { empty: true, sorted: false, unsorted: true },
          unpaged: false
        },
        size: content.length || 9999,
        sort: { empty: true, sorted: false, unsorted: true },
        totalElements: content.length,
        totalPages: 1
      } as PageableModel<LocationModel>;
    });
  return data;
  //old one
  //   const data = await api
  //   .get<PageableModel<LocationModel>>(PLAN + `/${planId}/locationHierarchy`)
  //   .then(response => response.data);
  // return data;
};

export const assignLocationsToPlan = async (planId: string, assignedLocations: string[]): Promise<any> => {
  let payload = {
    locations: assignedLocations
  };
  const data = await api
    .post<PageableModel<LocationModel>>(PLAN + `/${planId}/assignLocations`, payload)
    .then(response => response.data);
  return data;
};

export const assignLocationToPlan = async (planId: string, assignedLocation: string): Promise<any> => {
  const data = await api
    .post<PageableModel<LocationModel>>(PLAN + `/${planId}/assignLocation/${assignedLocation}`)
    .then(response => response.data);
  return data;
};

export const assignTeamsToMultiplePlanLocations = async (
  planId: string,
  assignedLocationIds: string[],
  teamIds: string[],
  assignChildren: boolean
): Promise<any> => {
  const data = await api
    .post<PageableModel<LocationModel>>(PLAN + `/${planId}/multipleTeamAssign`, {
      locations: assignedLocationIds,
      teams: teamIds,
      assignChildren: assignChildren
    })
    .then(response => response.data);
  return data;
};

export const getAssignedLocationHierarcyCount = async (planId: string): Promise<{ count: number }> => {
  const data = await api
    .get<{ count: number }>(PLAN + `/${planId}/locationHierarchy?_summary=COUNT`)
    // .get<{ count: number }>(`groupmanagement?_summary=count`)
    .then(response => response.data);
  return data;
};

export const assignTeamsToLocation = async (
  planId: string,
  locationId: string,
  teamIds: string[],
  assignChildren: boolean
): Promise<any> => {
  const data = await api
    .post(PLAN + `/${planId}/${locationId}/assignTeams`, { teams: teamIds, assignChildren: assignChildren })
    .then(response => response.data);
  return data;
};

export const assignTeamsToLocationHierarchy = async (
  planId: string,
  locationTeam: TeamAssignHierarchyRequest
): Promise<any> => {
  const data = await api
    .post(PLAN + `/${planId}/assignLocationHierarchyTeams`, locationTeam)
    .then(response => response.data);
  return data;
};

export const getAssignedTeamsByPlanAndLocationId = async (
  planId: string,
  locationId: string
): Promise<OrganizationModel[]> => {
  const data = await api
    .get<OrganizationModel[]>(PLAN + `/${planId}/${locationId}/teams`)
    .then(response => response.data);
  return data;
};

export const getChildLocation = async (locationId: string, planId: string): Promise<LocationModel[]> => {
  const data = await api
    .get<LocationModel[]>(LOCATION + `/${locationId}/children/${planId}`)
    .then(response => response.data);
  return data;
};

export const searchLocations = async (planId: string, search: string): Promise<{ value: string; label: string }[]> => {
  const data = await api
    .get<{ value: string; label: string }[]>(`plan/assignedLocations/${planId}?search=${search}`)
    .then(response => response.data);
  return data;
};

export const getLocationsAssignedToTeam = async (planId: string, teamId: string): Promise<{ value: string; label: string }[]> => {
  const data = await api
    .get<{ value: string; label: string }[]>(`plan/assignedLocationsToTeam/${planId}/${teamId}`)
    .then(response => response.data);
  return data;
};

export const saveLocationsAssignedToTeam = async (requestBody: { organizationIdentifier: string, locationIdentifiers: string[] }, planId: string): Promise<{ value: string; label: string }[]> => {
  const data = await api
    .post<{ value: string; label: string }[]>(`plan/assignLocationsToTeam/${planId}`, requestBody)
    .then(response => response.data);
  return data;
};

export const getLocationAssignments = async (): Promise<LocationModel[]> => {
  const data = await api
    .get<LocationModel[]>(`groupmanagement/instance/locationassignments`)
    .then(response => response.data);
  return data;
};
